import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
	constructor(m) {
		super(m);

		this.$slides = this.$('slide');
	}

	init() {
		this.index = 0;
		this.prevIndex = -1;
		this.launch(true);
	}

	launch(firstHit = false) {
		let nextSlide = this.index + 1;
		let nextnextSlide = this.index + 2;

		if(nextSlide > this.$slides.length - 1) {
			nextSlide = 0;
			nextnextSlide = 1;
		}

		if(nextnextSlide > this.$slides.length - 1) {
			nextnextSlide = 0;
		}

		this.$slides.forEach((slide, index) => {
			if(!firstHit && index == this.prevIndex) {
				slide.classList.add('is-leaving');
			} else {
				slide.classList.remove('is-leaving');
			}

			if(index == this.index) {
				slide.classList.add('is-active');
			} else {
				slide.classList.remove('is-active');
			}

			if(index == nextSlide) {
				slide.classList.add('is-next');
			} else {
				slide.classList.remove('is-next');
			}

			if(index == nextnextSlide) {
				slide.classList.add('is-nextnext');
			} else {
				slide.classList.remove('is-nextnext');
			}
		});
		
		gsap.delayedCall(2, () => {
			this.prevIndex = this.index;

			if(this.index < this.$slides.length - 1) {
				this.index++;
			} else {
				this.index = 0;
			}
			this.launch();
		});
	}
}
